import React from 'react'
import { EventModal } from '@src/modules/Events/shared/EventModal'
import { ViewLocationModal } from '@src/modules/Locations/shared/components/ViewLocationModal'
import { ViewRecordModal } from '@src/modules/Records/shared/ViewRecordModal'
import { ViewReportModal } from '@src/modules/Reports/shared/ViewReportModal'
import { create } from 'zustand'
import { LocationLogEntryModal, useCurrentUser } from '@therms/react-modules'

type AppModalState = {
  setShowEventModal: (eventId?: string) => void
  setShowLocationLogEntryModal: (entryId?: string) => void
  setShowLocationModal: (locationId?: string) => void
  setShowRecordModal: (recordId?: string) => void
  setShowReportModal: (reportId?: string) => void

  showEventModal?: { eventId: string }
  showLocationLogEntryModal?: { entryId: string }
  showLocationModal?: { locationId: string }
  showRecordModal?: { recordId: string }
  showReportModal?: { reportId: string }
}

export const useAppModalState = create<AppModalState>((set) => ({
  setShowEventModal: (eventId?: string) =>
    set({ showEventModal: eventId ? { eventId } : undefined }),
  setShowLocationLogEntryModal: (entryId?: string) =>
    set({ showLocationLogEntryModal: entryId ? { entryId } : undefined }),
  setShowLocationModal: (locationId?: string) =>
    set({ showLocationModal: locationId ? { locationId } : undefined }),
  setShowRecordModal: (recordId?: string) =>
    set({ showRecordModal: recordId ? { recordId } : undefined }),
  setShowReportModal: (reportId?: string) =>
    set({ showReportModal: reportId ? { reportId } : undefined }),

  showEventModal: undefined,
  showLocationLogEntryModal: undefined,
  showLocationModal: undefined,
  showRecordModal: undefined,
  showReportModal: undefined,
}))

export function AppModals() {
  const state = useAppModalState()
  const user = useCurrentUser()

  if (state.showEventModal && !!user.anp.role.portal.access.viewEvents) {
    return (
      <EventModal
        closeHandler={() => state.setShowEventModal(undefined)}
        eventId={state.showEventModal.eventId}
      />
    )
  }

  if (
    state.showLocationLogEntryModal &&
    !!user.anp.role.portal.access.viewLocationLogs
  ) {
    return (
      <LocationLogEntryModal
        closeHandler={() => state.setShowLocationLogEntryModal(undefined)}
        entryId={state.showLocationLogEntryModal.entryId}
      />
    )
  }

  if (
    state.showLocationModal &&
    (user.anp.locations.locationAndGroupIds.includes(
      state.showLocationModal.locationId || 'loc-',
    ) ||
      user.anp.locations.locationAndGroupIds.includes('loc-'))
  ) {
    return (
      <ViewLocationModal
        closeHandler={() => state.setShowLocationModal(undefined)}
        locationId={state.showLocationModal.locationId}
      />
    )
  }

  if (state.showRecordModal && !!user.anp.role.portal.access.viewRecords) {
    return (
      <ViewRecordModal
        closeHandler={() => state.setShowRecordModal(undefined)}
        recordId={state.showRecordModal.recordId}
      />
    )
  }

  if (state.showReportModal && !!user.anp.role.portal.access.viewReports) {
    return (
      <ViewReportModal
        closeHandler={() => state.setShowReportModal(undefined)}
        reportId={state.showReportModal.reportId}
      />
    )
  }

  return null
}
